import { ArrowRight } from "lucide-react";
import { FadeIn } from "./FadeIn";

const CALENDLY = "https://calendly.com/katie-fernands/discovery-call";
import katieAsset from "@/assets/katie-fernands.webp.asset.json";

export function WhyWorkWithMe() {
  return (
    <section className="bg-dark text-on-dark py-28 md:py-40">
      <div className="mx-auto max-w-6xl px-6 lg:px-10">
        <div className="flex items-center gap-4 mb-16">
          <span className="text-xs uppercase tracking-[0.28em] text-white/90">Your guide</span>
          <span className="h-px flex-1 bg-white/15" />
          <span className="text-xs tracking-[0.2em] text-white/70">IV</span>
        </div>

        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <FadeIn className="lg:col-span-5">
            <div className="lg:sticky lg:top-24">
              <div className="photo-frame">
                <img
                  src={katieAsset.url}
                  alt="Katie Fernands"
                  loading="lazy"
                  className="w-full max-w-xs aspect-[4/5] object-cover object-top photo-edit hover:photo-edit-hover"
                />
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.1} className="lg:col-span-7">
            <h2 className="text-4xl md:text-6xl leading-[1.05] tracking-tight mb-10">
              You've built the expertise. I'll help you build the pipeline.
            </h2>

            <div className="space-y-6 text-white/75 leading-relaxed text-lg max-w-2xl">
              <p className="first-letter:font-serif first-letter:text-6xl first-letter:leading-[0.85] first-letter:float-left first-letter:mr-3 first-letter:mt-1 first-letter:text-sage">
                Most advisors I meet are exceptional at their craft and quietly frustrated with growth.
                Referrals arrive in waves, LinkedIn feels like homework, and the "cold outreach"
                playbook doesn't match how anyone actually chooses a financial professional.
              </p>
              <p>
                I've spent fifteen years in financial services, as Vice President of Growth Marketing
                for U.S. Bank Wealth Management and Director of Marketing at Prudential Financial,
                alongside independent RIA and fintech teams. I build the kind of growth engine that
                respects your reputation and your calendar.
              </p>
              <p>
                Together we'll turn the trust you've already earned, your network, your voice, and
                your point of view, into a steady inbound pipeline.
              </p>
            </div>

            <figure className="mt-14 border-t border-white/15 pt-10 max-w-2xl">
              <blockquote className="text-xl md:text-2xl italic text-white/90 leading-snug">
                &ldquo;The program led by Katie helped me land a meeting with a former contact due to
                my regular and consistent visibility plan.&rdquo;
              </blockquote>
              <figcaption className="mt-5 text-sm tracking-[0.18em] uppercase text-white/50">
                Maryls &nbsp;·&nbsp; Family Office Partner
              </figcaption>
            </figure>

            <div className="mt-10">
              <a
                href={CALENDLY}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-6 py-3 text-sm font-medium hover:opacity-90 transition-opacity"
              >
                Book a discovery call
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </a>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}
